/**
 * 金融行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/finance-solution';

const Finance = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="金融行业解决方案"
      simpleDesc="以创新科技 助推金融行业数字化转型"
      desc={`小鱼易连以“数字化、科技引领、创新赋能”为整体布局驱动，为金融行业提\n供安全、便捷的云视频中台服务，适应金融业务需求和网络条件灵活部署，\n助力金融机构实现管理数字化、科技化、智能化。`}
      pageTitle="金融行业"
      tdkWord="finance"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default Finance;
